<ion-card class="main-card card-transition">
  <ion-card-subtitle class="metrics-card-subtitle">{{ title | translate}}
  </ion-card-subtitle>
  <ion-card-content class="metrics-card-content">
    {{data}}
  </ion-card-content>
</ion-card>
